import get from 'lodash/get';

const getPharmacies = async (setPharmacy, query) => {
  const cleanQuery = query.toLowerCase().trim();

  const body = {
    query: cleanQuery,
    hitsPerPage: 950,
  };
  const response = await fetch(
    `https://${process.env.RAZZLE_ALGOLIA_APPID}-dsn.algolia.net/1/indexes/${process.env.RAZZLE_ALGOLIA_INDEX}/query`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Algolia-API-Key': process.env.RAZZLE_ALGOLIA_APIKEY_SECURED,
        'X-Algolia-Application-Id': process.env.RAZZLE_ALGOLIA_APPID,
      },
      body: JSON.stringify(body),
    }
  );
  const algoliaResponse = await response.json();
  const pharmacies = get(algoliaResponse, 'hits', []);
  pharmacies.sort((a, b) => a.name.localeCompare(b.name));
  setPharmacy(pharmacies);
};

export { getPharmacies };
